import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../utils/imageUtils";

const HeroSection = ({ t, lang, data }) => {
    return (
        <header className="bg-body overflow-hidden" id="header-index">
            <div className="video-background">
                <video autoPlay muted loop playsInline id="video-index">
                    <source src={getImageUrl('v.webm', 'imgWeb')} type="video/mp4" />
                </video>
            </div>

            <div className="layout-header-index"></div>

            <div className="container py-5">
                <div className="row align-items-center gy-5">
                    <div className="col-lg-6" data-aos="zoom-in">
                        <h1 className="display-4 fw-bold mb-4">
                            {t("home_hero_title")}
                        </h1>

                        <p className="lead mb-4">
                            {t("home_hero_desc")}
                        </p>

                        <div className="d-flex gap-3">
                            <Link to="/contact" className="btn btn-primary-custom btn-lg">
                                {lang === "en" ? "Get Started" : "ابدأ الآن"}{" "}
                                <i className="ri-arrow-right-line"></i>
                            </Link>

                            <Link to="/projects" className="btn btn-outline-custom btn-lg">
                                {lang === "en" ? "View Work" : "شاهد أعمالنا"}
                            </Link>
                        </div>
                    </div>

                    <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
                        <img
                            src={
                                data.static_en.img_hero
                                    ? getImageUrl(data.static_en.img_hero, 'imgWeb')
                                    : "https://images.unsplash.com/photo-1522071820081-009f0129c71c"
                            }
                            alt="Team collaboration"
                            className="img-fluid rounded-custom shadow-lg"
                        />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default HeroSection;